import { SupportForm, SupportHeader } from '@/features/support';
import { BaseModal } from '@/lib/Modals';
import { ComponentProps, FC } from 'react';

type SupportModalProps = Pick<ComponentProps<typeof BaseModal>, 'onClose'> & ComponentProps<typeof SupportForm>;

export const SupportModal: FC<SupportModalProps> = ({ onConfirm, onClose }) => {
  return (
    <BaseModal classNames={{ dialog: 'max-w-full ' }} onClose={onClose}>
      <div className='flex h-[31.25rem] w-auto flex-col gap-5 rounded-lg bg-[url("/assets/image/bg-support-modal.svg")] bg-cover bg-[50px_45px] bg-no-repeat px-4 py-6 sm:w-[560px] sm:bg-[200px_45px] sm:p-6'>
        <SupportHeader />
        <SupportForm onConfirm={onConfirm} />
      </div>
    </BaseModal>
  );
};
